export default class Api {
    // static baseUrl = 'http://192.227.137.46:8082'
    static baseUrl = ''
    static user = {
        // token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOiIxNzc0NjYyODQ3IiwiaWF0IjoiMTc3NDY1OTI0NyIsInV1aWQiOiI3N2YyYWUyNC1iYmVlLTQ3MDItYjUzYy04NTY1Zjk4NTdmNzgifQ.wU2421QKyAeKpioHCioBBJv8Nie067U5Y2u8C93RAj0'
    }
    static getHeader() {
        if (!this.user.token) {
            return {
                'Content-Type': 'application/json'
            }
        } else {
            return {
                'X-Token': this.user.token,
                'Content-Type': 'application/json'
            }
        }

    }
    static post(url, data) {
        return fetch(this.baseUrl + url, {
            method: 'POST',
            headers: this.getHeader(),
            body: JSON.stringify(data)
        })
    }
    static get(url, params) {
        if (params) {
            url += '?' + new URLSearchParams(params).toString()
        }
        return fetch(this.baseUrl + url, {
            method: 'GET',
            headers: this.getHeader()
        })
    }
}
